define(["mw-remote/serviceRegistryLookup","/mathworks/hub/share/apps/iat/javascript_build_harness/R2020b/2.18.7/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js",""], function(loader, runner) {
   return runner(loader, "", __webpack_require__.dj.c(), true);
});